import { useEffect, useState } from 'react';
import { fetchSyncStatus } from '../api/dashboard';

/** 'tally' | 'zoho' | null while loading / on error */
export function useWorkspaceSyncTool(workspace) {
  const [tool, setTool] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchSyncStatus(workspace)
      .then((d) => {
        if (!cancelled) setTool(d.tool === 'zoho' ? 'zoho' : 'tally');
      })
      .catch(() => {
        if (!cancelled) setTool(null);
      });
    return () => {
      cancelled = true;
    };
  }, [workspace]);

  return tool;
}
